import * as React from 'react'

const SvgArrowUpCircleOutlined = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.5 7.91364C1.5 4.32402 4.40996 1.41406 7.99958 1.41406C11.5892 1.41406 14.4992 4.32402 14.4992 7.91364C14.4992 11.5033 11.5892 14.4132 7.99958 14.4132C4.40996 14.4132 1.5 11.5033 1.5 7.91364ZM7.46936 4.98809C7.76225 4.69519 8.23713 4.69519 8.53002 4.98809L10.4465 6.90461C10.7394 7.19751 10.7394 7.67238 10.4465 7.96527C10.1537 8.25817 9.67878 8.25817 9.38589 7.96527L8.74971 7.3291L8.74971 10.47C8.74971 10.8842 8.41392 11.22 7.99971 11.22C7.58549 11.22 7.24971 10.8842 7.24971 10.47L7.24971 7.32906L6.61349 7.96527C6.3206 8.25817 5.84573 8.25817 5.55283 7.96527C5.25994 7.67238 5.25994 7.19751 5.55283 6.90461L7.46936 4.98809Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgArrowUpCircleOutlined
